import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: "uniteTempsFilter"
})

export class UniteTempsPipe implements PipeTransform{
    transform(uniteTemps: string) {
        switch(uniteTemps) {
            case "HS" :
                uniteTemps = "Heures/Semaines"
                break;
            case "HA" :
                uniteTemps = "Heures/Annuel"
                break;
            case "JA" :
                uniteTemps = "Jours/Annuel"
                break;
        }
        return uniteTemps;
    }
}